import { useTranslation, type TFunction } from '@mint-lib/i18n';
import { Chip } from '@mint-lib/tw-components';
import { Suggestions } from '@mint-sdk/api-recommendations';

import type { SuggestionHeaderStatus } from '../../../types/chips.js';
import { suggestionChipColors } from '../../../utils/chips.js';

type Props = {
  type:
    | SuggestionHeaderStatus
    | 'Original'
    | 'ReworkedHeadline'
    | 'ReworkedCard'
    | 'Published'
    | 'ReadyForPublishing';
};

const getChipProps = (type: Props['type'], t: TFunction) => {
  switch (type) {
    case Suggestions.Statuses.ACCEPTED:
      return { color: suggestionChipColors.ACCEPTED, label: t('Accepted') };
    case Suggestions.Statuses.ERROR:
      return { color: suggestionChipColors.ERROR, label: t('Error') };

    case Suggestions.Statuses.REWORKING:
      return { color: suggestionChipColors.REWORKING, label: t('Reworking') };

    case Suggestions.Statuses.ACCEPTING:
      return {
        color: suggestionChipColors.ACCEPTING,
        label: t('Pending application'),
      };

    case Suggestions.Statuses.REJECTED:
      return { color: suggestionChipColors.REJECTED, label: t('Rejected') };

    case Suggestions.Statuses.EXPIRED:
      return { color: suggestionChipColors.EXPIRED, label: t('Expired') };

    case 'Original':
      return { color: suggestionChipColors.ORIGINAL, label: t('Original') };
    case 'ReworkedHeadline':
      return {
        color: suggestionChipColors.REWORKED_HEADLINE,
        label: t('Reworked'),
      };
    case 'ReworkedCard':
      return {
        color: suggestionChipColors.REWORKED_CARD,
        label: t('Reworked'),
      };
    case 'Published':
      return { color: suggestionChipColors.PUBLISHED, label: t('Published') };
    case 'ReadyForPublishing':
      return {
        color: suggestionChipColors.READY_FOR_PUBLISHING,
        label: t('Ready for publishing'),
      };
  }
};

const SeparateStatusChip = ({ type }: Props) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  const selectedChip = getChipProps(type, t);

  return (
    <Chip
      className={'h-5 whitespace-nowrap hover:bg-transparent'}
      color={selectedChip.color}
      variant={'outline'}
    >
      {selectedChip.label}
    </Chip>
  );
};

export default SeparateStatusChip;
